import { bestBallPlugin, stablefordPlugin } from './plugins/team';
import { matchPlayPlugin, netStrokePlugin, strokePlugin } from './plugins/stroke';
import { nassauPlugin, skinsPlugin, teamNassauPlugin } from './plugins/wager';
import { quotaPlugin } from './plugins/quota';
import { puttsBetPlugin } from './plugins/putts-bet';
import {
  dotsPlugin,
  ryderCupPlugin,
  scramblePlugin,
  shamblePlugin,
  sixesPlugin,
  vegasPlugin,
  wolfPlugin,
} from './plugins/special';
import {
  aggregatePlugin,
  fourBallPlugin,
  highLowPlugin,
  teamMatchPlayPlugin,
  teamStablefordPlugin,
} from './plugins/team-extended';
import { findCatalogEntry } from '@/lib/games/game-catalog';
import type { GamePlugin } from './types';

const PLUGINS: GamePlugin[] = [
  strokePlugin,
  netStrokePlugin,
  matchPlayPlugin,
  skinsPlugin,
  nassauPlugin,
  teamNassauPlugin,
  stablefordPlugin,
  bestBallPlugin,
  quotaPlugin,
  dotsPlugin,
  puttsBetPlugin,
  wolfPlugin,
  sixesPlugin,
  scramblePlugin,
  shamblePlugin,
  ryderCupPlugin,
  vegasPlugin,
  fourBallPlugin,
  teamMatchPlayPlugin,
  aggregatePlugin,
  highLowPlugin,
  teamStablefordPlugin,
];

const byId = new Map(PLUGINS.map((p) => [p.id, p]));

export function resolvePluginId(formatId: string): string {
  const entry = findCatalogEntry(formatId);
  return entry?.pluginId ?? formatId;
}

export function getGamePlugin(formatId: string): GamePlugin | undefined {
  return byId.get(resolvePluginId(formatId));
}

export function isMatchFormat(formatId: string): boolean {
  return getGamePlugin(formatId)?.isMatch === true;
}

export function listGamePlugins(): GamePlugin[] {
  return PLUGINS;
}

export function requiresTeams(enabledIds: string[]): boolean {
  return enabledIds.some((id) => {
    const entry = findCatalogEntry(id);
    if (entry) return entry.requiresTeams;
    return byId.get(id)?.requiresTeams;
  });
}

export function catalogRequiresTeams(enabledIds: string[]): boolean {
  return requiresTeams(enabledIds);
}
